import React, {memo, useState} from 'react';
import cn from 'classnames';
import {Button, BUTTON_THEMES} from 'ht-styleguide';
import useScrollTrigger from '@hooks/useScrollTrigger';
import ButtonFooter from '@components/UI/ButtonFooter';
import styles from './servicebooknow.module.scss';

type ServiceBookNowProps = {
  className?: string;
  sku: {
    ctaText?: string;
  };
  trigger?: string;
  onBook: BaseAnyFunction;
};

const ServiceBookNow = ({className, trigger = '#service-book-now-trigger', sku, onBook}: ServiceBookNowProps) => {
  const [visible, setVisible] = useState(false);
  const boxStyles = cn(styles.box, {[styles.visible]: visible}, className);
  useScrollTrigger({
    trigger,
    onReach: v => setVisible(v),
  });
  return (
    <ButtonFooter className={boxStyles} showMobile={visible} showTablet={false}>
      <Button small theme={BUTTON_THEMES.PRIMARY} onClick={onBook}>
        {sku.ctaText}
      </Button>
    </ButtonFooter>
  );
};

export default memo(ServiceBookNow);
